export default {
  name: "not-registered-sheba-card",
  components: {},
  props: {
    data: {
      type: String
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    handleAddCard() {
      this.$emit("confirmAddShebaAgain", true);
    }
  }
};
